var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardPlayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 205 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 2V2C12.3406 2 10.0109 2 8.17317 2.7612C5.72288 3.77614 3.77614 5.72288 2.7612 8.17317C2 10.0109 2 12.3406 2 17V17",
    stroke: "url(#g)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 64V64C12.3406 64 10.0109 64 8.17317 63.2388C5.72288 62.2239 3.77614 60.2771 2.7612 57.8268C2 55.9891 2 53.6594 2 49V49",
    stroke: "url(#f)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188 2v0c4.659 0 6.989 0 8.827 0.7612 2.45 1.0149 4.397 2.9617 5.412 5.412 0.761 1.8377 0.761 4.1674 0.761 8.8268v0",
    stroke: "url(#e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188 64v0c4.659 0 6.989 0 8.827-0.7612 2.45-1.0149 4.397-2.9617 5.412-5.412 0.761-1.8377 0.761-4.1674 0.761-8.8268v0",
    stroke: "url(#d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.82 54.377c-13.239 7.3735-32.011 0.6728-36.576-8.0303-3.001-6.3678-0.867-12.801 3.834-16.127 6.816-4.8218 13.795-2.2981 17.911-4.8891 5.318-3.3478 4.719-9.7312 10.913-11.484 4.319-1.2223 13.575 3.7067 16.345 15.027 2.146 8.7709-0.851 19.057-12.427 25.503z",
    fill: "url(#c)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.82 54.377c-13.239 7.3735-32.011 0.6728-36.576-8.0303-3.001-6.3678-0.867-12.801 3.834-16.127 6.816-4.8218 13.795-2.2981 17.911-4.8891 5.318-3.3478 4.719-9.7312 10.913-11.484 4.319-1.2223 13.575 3.7067 16.345 15.027 2.146 8.7709-0.851 19.057-12.427 25.503z",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.294 11.454c-9.2825 5.0026-15.413 14.02-13.647 26.316 1.6385 11.411 12.276 20.605 21.491 18.993 8.1869-1.4319 10.733-13.646 17.291-15.726 5.0878-1.6133 11.581 4.0854 17.478 3.9374 5.898-0.1481 12.526-5.3799 13.302-14.116 0.92-10.348-7.083-16.025-10.141-17.628-4.4044-2.3077-8.2663-1.613-10.491-0.6812-2.3076 0.9665-3.21 1.4769-5.9316 1.578s-4.4476-0.8561-6.737-1.8755c-2.2893-1.0194-13-5.9793-22.614-0.7981z",
    stroke: "#6ED2FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.294 11.454c-9.2825 5.0026-15.413 14.02-13.647 26.316 1.6385 11.411 12.276 20.605 21.491 18.993 8.1869-1.4319 10.733-13.646 17.291-15.726 5.0878-1.6133 11.581 4.0854 17.478 3.9374 0.717-0.018 1.445-0.1112 2.172-0.2766 0.436-0.0992 0.871-0.2243 1.303-0.3748 0.456-0.1585 0.908-0.3452 1.354-0.5592 4.234-2.0329 7.908-6.5384 8.473-12.905 0.92-10.348-7.083-16.025-10.141-17.628-4.4044-2.3077-8.2663-1.613-10.491-0.6812-2.3076 0.9665-3.21 1.4769-5.9316 1.578s-4.4476-0.8561-6.737-1.8755c-2.2893-1.0194-13-5.9793-22.614-0.7981z",
    fill: "url(#a)",
    opacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 17,
    x2: 1.0884,
    y1: 1.5213,
    y2: 2.2791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 17,
    x2: 1.0884,
    y1: 64.479,
    y2: 63.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 188,
    x2: 203.91,
    y1: 1.5213,
    y2: 2.2791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 188,
    x2: 203.91,
    y1: 64.479,
    y2: 63.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 103.76,
    x2: 152.4,
    y1: 18.449,
    y2: 48.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    stopOpacity: 0.6,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    stopOpacity: 0.03,
    offset: 0.89785
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 97.673,
    x2: 127.22,
    y1: 44.139,
    y2: 1.1278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5003",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 73.607,
    x2: 77.227,
    y1: 80.931,
    y2: 7.3375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ED2FA",
    stopOpacity: 0.7,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ED2FA",
    stopOpacity: 0.05,
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 66,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPlayer);
export default __webpack_public_path__ + "static/media/card-player.b090ad70c1b35530b261f73c256b149a.svg";
export { ForwardRef as ReactComponent };